import { useTranslation } from 'react-i18next';
import React, { useCallback, useMemo } from 'react';
import styles from './index.module.scss';
import { IconShare } from '@/assets/proposals';
import clsx from 'clsx';
import { Dropdown } from '@/components';
import { copyFn } from '@/components/shared/CopyImage';
import { useFeedCreate } from '@/views/Stream';
import { message } from 'antd';
import { toastError } from '@/utils';

export const ShareBtn = ({ id, className }: { id: number; className?: string }) => {
  const { t } = useTranslation();
  const { mutateAsync: createStream } = useFeedCreate(true);
  const handelCopy = useCallback(() => {
    copyFn(`https://debank.com/proposal/${id}`);
  }, [id]);
  const handelShare = useCallback(async () => {
    try {
      const res = await createStream({
        content: '',
        type: 'data_proposal',
        proposal_id: id,
      });
      // 在分享场景下，自定义toast，不使用创建stream默认toast
      if (res?.article?.id) {
        message.success('Shared');
      }
    } catch (err) {
      toastError(err || 'Failed');
    }
  }, [createStream, id]);
  const menus = useMemo(
    () => [
      {
        label: <span className={styles.item}>{t('ShareBtn.1l2rmp1')}</span>,
        onClick: handelCopy,
      },
      {
        label: <span className={styles.item}>{t('ShareBtn.624bmo')}</span>,
        onClick: handelShare,
      },
    ],
    [handelCopy, handelShare, t],
  );
  return (
    <Dropdown data={menus} placement={'bottomRight'}>
      <div className={clsx(styles.container, className)}>
        <IconShare className={styles.icon} />
        {t('ShareBtn.1bjem7')}
      </div>
    </Dropdown>
  );
};
